import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { DialogueCard } from '../story/DialogueCard';
import { ChipGroup } from '../story/ChipGroup';
import { ActionRow } from '../story/ActionRow';
import { Button } from '../story/Button';
import { SceneIllustration } from '../art/SceneIllustration';
import { SavannaScene } from '../art/SavannaScene';
import { arrivalRecap, arrivalReplies } from '../../data/savanna';
import { AMARA_MENTOR } from '../../data/speakers';
const SCENE_TEXT = 'Amber dawn over Savanna City. Solar shade roofs, acacia roots, gardens, and water channels. Monkey is near the water. Giraffe stands in shade. Meerkats sit on a wall. Panther faces the grass.';
export function ArrivalScreen() {
  const {
    state,
    dispatch,
    world
  } = useDemo();
  const reply = arrivalReplies.find(item => item.id === state.arrivalReply);
  return <ScreenContainer data-id="element-79" data-mp="1atcxoindx9ez">
      <ScreenHeading eyebrow="Garden 1" data-id="element-80" data-mp="1asjx5zf0rg5a">Savanna City</ScreenHeading>
      <div className="mt-6 grid gap-8 lg:grid-cols-[1.35fr_1fr] lg:items-start" data-id="element-81" data-mp="15ua0tlhk69i3">
        <SceneIllustration description={SCENE_TEXT} quietTitle="Savanna City" data-id="element-82" data-mp="1kkpl8y25hdf7">
          <SavannaScene world={world} label={SCENE_TEXT} data-id="element-83" data-mp="1fl4manmzd52h" />
        </SceneIllustration>
        <div className="flex flex-col gap-4" data-id="element-84" data-mp="1fnh3gykwzbeh">
          <DialogueCard line={{
          kind: 'speech',
          speaker: AMARA_MENTOR,
          text: 'You made it. Nice. I was worried the Bridge got picky.'
        }} data-id="element-85" data-mp="rwlf6bfo2ybz" />
          <ChipGroup legend="Your reply" options={arrivalReplies.map(item => item.label)} value={reply?.label} onSelect={label => {
          const chosen = arrivalReplies.find(item => item.label === label);
          if (chosen) dispatch({
            type: 'SET_ARRIVAL_REPLY',
            reply: chosen.id
          });
        }} data-id="element-86" data-mp="10w8hczg80863" />
          {reply && <div key={reply.id} className="anim-enter" aria-live="polite" data-id="element-87" data-mp="14yv2x2wf8qt9">
              <DialogueCard line={{
            kind: 'speech',
            speaker: AMARA_MENTOR,
            text: reply.response
          }} data-id="element-88" data-mp="150z3bav437os" />
            </div>}
        </div>
      </div>

      <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-89" data-mp="1ewspzn2johka">
        <div data-id="element-90" data-mp="1ev7u9u4husku">
          <h2 className="font-display text-2xl font-semibold text-forest" data-id="element-91" data-mp="1iynrarkh6uy2">Day 1, so far</h2>
          <p className="mt-2 max-w-prose" data-id="element-92" data-mp="m8dcj4z2a7b2">{arrivalRecap}</p>
        </div>
        <div className="rounded-2xl border border-line bg-paper p-5 hc-strong" data-id="element-93" data-mp="ma7xgjac1zf5">
          <p className="text-sm font-bold text-teal" data-id="element-94" data-mp="r89devcgpime">Today’s scene: Signal or Static</p>
          <div className="mt-3" data-id="element-95" data-mp="v80crng2172j">
            <DialogueCard line={{
            kind: 'speech',
            speaker: AMARA_MENTOR,
            text: 'We are sorting signals. It gives our attention somewhere to stand.'
          }} data-id="element-96" data-mp="v6ypmklrku4g" />
          </div>
        </div>
      </div>

      <ActionRow onBack={() => dispatch({
      type: 'BACK'
    })} data-id="element-97" data-mp="7jh77foe38e5">
        <Button onClick={() => dispatch({
        type: 'GO',
        screen: 'clues'
      })} iconAfter={<ArrowRightIcon size={18} aria-hidden="true" data-id="element-99" data-mp="3w4u0j611benk" />} data-id="element-98" data-mp="7hxqxp2qgxcd">
          Look at the clues
        </Button>
      </ActionRow>
    </ScreenContainer>;
}